import { useCallback, useState } from "react"

import { useEvent } from "./useEvent"
import { useFocus } from "./useFocus"

export function useFocusState<T extends HTMLElement = HTMLElement>() {
  const [element, setElement] = useState<T | null>(null)
  const [isFocused, setIsFocused] = useState(false)

  const ref = useCallback((node: T | null) => setElement(node), [])
  const onFocus = useEvent(() => setIsFocused(true))
  const onBlur = useEvent(() => setIsFocused(false))

  useFocus({ element, onFocus, onBlur })

  return { ref, isFocused }
}
